module.exports = __webpack_public_path__ + "static/ramen-b06d58d047d9880db81d83961daf2eaa.gif";